<script>
  import {IMAGES} from '../images';

  export let item;
</script>

<style>
  .title {
    margin-top: 0;
    font-family: gilroy-bold;
  }
  .card {
    border-radius: 20px;
    width: 338px;
    height: 156px;
    background: #f9f9f9;
  }
  .card + :global(.card) {
    margin-left: 20px;
  }
  .brands {
    overflow: hidden;
  }
  .scroller {
    height: 48px;
  }
  .brands img {
    margin-left: 12px;
  }
  .brands.first img {
    margin-left: 24px;
  }
  .brands img:first-child,
  .brands.first img:first-child {
    margin-left: 0;
  }
  .brands::-webkit-scrollbar {
    width: 0;
  }
  .brands:hover.first .scroller {
    animation: move 2s linear infinite;
  }
  @media screen and (max-width: 640px) {
    .card {
      width: auto;
    }
    .card + :global(.card) {
      margin: 20px 0 0 0;
    }
    .title {
      font-size: 18px;
    }
    .desc {
      font-size: 14px;
    }
    .brands {
      width: 338px;
    }
    .brands:hover.first .scroller {
      animation: none;
    }
  }
  @keyframes move {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(-320px, 0);
    }
  }
</style>

<div class="card df fdc jcsb p24">
  <div>
    <h3 class="title f24 mb12">{item.title}</h3>
    <div class="desc f16">{item.desc}</div>
  </div>
  <div class={`brands ${item.class}`}>
    <div class="scroller df aifs">
      {#each item.imgs as img}
        <img height="100%" src={IMAGES[img.img]} alt={img.alt} />
      {/each}
    </div>
  </div>
</div>
